var app;

app = window.App || (window.App = {});

app.EventKindPreconditions = {
  showFields: function(e) {
    e.preventDefault();
    $('#event_kind_precondition_kind_ids').val([]);
    $('#add_precondition_grouping').hide();
    return $('#precondition_fields').slideDown();
  },
  hideFields: function(e) {
    e.preventDefault();
    $('#precondition_fields').slideUp();
    return $('#add_precondition_grouping').show();
  },
  removePreconditions: function(e) {
    e.preventDefault();
    $(this).parents('.precondition-grouping').remove();
    return $('.precondition-grouping:first-child .muted').remove();
  },
  addPreconditions: function(e) {
    var grouping, html, ids, obj, validity;
    e.preventDefault();
    obj = app.EventKindPreconditions;
    ids = $('#event_kind_precondition_kind_ids').val();
    validity = $('#event_kind_precondition_kind_validity').val();
    if (ids.length) {
      grouping = $('.precondition-grouping').length;
      html = '<div class="precondition-grouping row mt-2">' + ids.map(function(id) {
        return obj.buildHiddenField(grouping, id);
      }).join(' ') + obj.buildConjunction(grouping) + '<div>' + obj.buildSentence() + obj.buildRemoveLink() + '</div>' + obj.buildValidityFields(grouping) + '</div>';
      $('#add_precondition_grouping').before(html);
    }
    return obj.hideFields(e);
  },
  buildHiddenField: function(grouping, id) {
    return '<input name="event_kind[precondition_qualification_kinds][' + grouping + '][qualification_kind_ids][]" type="hidden" value="' + id + '" />';
  },
  buildValidityFields: function(grouping) {
    var validId, validOrExpiredId, validOrReactivatableId;
    validId = 'event_kind_precondition_qualification_kinds_' + grouping + '_valid';
    validOrExpiredId = 'event_kind_precondition_qualification_kinds_' + grouping + '_valid_or_expired';
    validOrReactivatableId = 'event_kind_precondition_qualification_kinds_' + grouping + '_valid_or_reactivatable';
    return '<label class="precondition-validity radio" for="' + validId + '"><input class="me-2" id="' + validId + '" name="event_kind[precondition_qualification_kinds][' + grouping + '][validity]" type="radio" value="valid" />' + $('#precondition_summary').data('validity-valid') + '</label>' + '<label class="precondition-validity radio" for="' + validOrReactivatableId + '"><input class="me-2" id="' + validOrReactivatableId + '" name="event_kind[precondition_qualification_kinds][' + grouping + '][validity]" type="radio" value="valid_or_reactivatable" checked="checked" />' + $('#precondition_summary').data('validity-valid-or-reactivatable') + '</label>' + '<label class="precondition-validity radio" for="' + validOrExpiredId + '"><input class="me-2" id="' + validOrExpiredId + '" name="event_kind[precondition_qualification_kinds][' + grouping + '][validity]" type="radio" value="valid_or_expired" checked="checked" />' + $('#precondition_summary').data('validity-valid-or-expired') + '</label>';
  },
  buildConjunction: function(grouping) {
    if (grouping) {
      return '<span class="muted">' + $('#precondition_summary').data('or') + '</span> ';
    } else {
      return '';
    }
  },
  buildRemoveLink: function() {
    return ' <a href="#" class="remove-precondition-grouping"><i class="far fa-trash-alt"></i></a>';
  },
  buildSentence: function() {
    var labels, last;
    labels = app.EventKindPreconditions.fetchLabels();
    last = labels.pop();
    if (labels.length) {
      return labels.join(', ') + ' ' + $('#precondition_summary').data('and') + ' ' + last;
    } else {
      return last;
    }
  },
  fetchLabels: function() {
    var labels;
    labels = [];
    $('#event_kind_precondition_kind_ids option:selected').each(function(i, option) {
      return labels.push($(option).text());
    });
    return labels;
  }
};

$(document).on('click', '#add_precondition_grouping', app.EventKindPreconditions.showFields);

$(document).on('click', '#precondition_fields .cancel', app.EventKindPreconditions.hideFields);

$(document).on('click', '#precondition_fields button', app.EventKindPreconditions.addPreconditions);

$(document).on('click', '.remove-precondition-grouping', app.EventKindPreconditions.removePreconditions);
